import apiClient from '@services/api/apiClient.jsx';

/**
 * 테마 프레임 매핑 API 서비스
 */
const themeFrameMappingApi = {
    /**
     * 테마별 프레임 매핑 목록 조회
     */
    getThemeFrameMappings: async (themeId) => {
        try {
            const response = await apiClient.get(`/theme-frame-mappings`, {
                params: { themeId }
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 프레임 매핑 목록 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 특정 테마 프레임 매핑 조회
     */
    getThemeFrameMapping: async (mappingId) => {
        try {
            const response = await apiClient.get(`/theme-frame-mappings/${mappingId}`);
            return response.data.data;
        } catch (error) {
            console.error('테마 프레임 매핑 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 추가 가능한 프레임 목록 조회
     */
    getAvailableFrames: async (themeId) => {
        try {
            const response = await apiClient.get(`/theme-frame-mappings/available-frames`, {
                params: { themeId }
            });
            return response.data.data;
        } catch (error) {
            console.error('사용 가능한 프레임 목록 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 테마에 프레임 추가
     */
    addFrameToTheme: async (themeId, photoFrameId, customImages = {}) => {
        try {
            const formData = new FormData();
            formData.append('themeId', themeId);
            formData.append('photoFrameId', photoFrameId);

            if (customImages.defaultImageResourceId) {
                formData.append('customDefaultImageResourceId', customImages.defaultImageResourceId);
            }
            if (customImages.hoverImageResourceId) {
                formData.append('customHoverImageResourceId', customImages.hoverImageResourceId);
            }
            if (customImages.displayOrder) {
                formData.append('displayOrder', customImages.displayOrder);
            }

            const response = await apiClient.post(`/theme-frame-mappings`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data.data;
        } catch (error) {
            console.error('테마에 프레임 추가 실패:', error);
            throw error;
        }
    },

    /**
     * 테마 프레임 매핑 수정
     */
    updateThemeFrameMapping: async (mappingId, updateData) => {
        try {
            const formData = new FormData();

            if (updateData.customDefaultImageResourceId !== undefined) {
                formData.append('customDefaultImageResourceId', updateData.customDefaultImageResourceId || '');
            }
            if (updateData.customHoverImageResourceId !== undefined) {
                formData.append('customHoverImageResourceId', updateData.customHoverImageResourceId || '');
            }
            if (updateData.displayOrder !== undefined) {
                formData.append('displayOrder', updateData.displayOrder);
            }
            if (updateData.isActive !== undefined) {
                formData.append('isActive', updateData.isActive);
            }

            const response = await apiClient.put(`/theme-frame-mappings/${mappingId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 프레임 매핑 수정 실패:', error);
            throw error;
        }
    },

    /**
     * 테마에서 프레임 제거
     */
    removeFrameFromTheme: async (mappingId) => {
        try {
            const response = await apiClient.delete(`/theme-frame-mappings/${mappingId}`);
            return response.data.success;
        } catch (error) {
            console.error('테마에서 프레임 제거 실패:', error);
            throw error;
        }
    },

    /**
     * 프레임 순서 변경
     */
    reorderFrames: async (themeId, mappingOrders) => {
        try {
            const requestData = {
                themeId,
                mappingOrders
            };

            const response = await apiClient.put(`/theme-frame-mappings/reorder`, requestData);
            return response.data.success;
        } catch (error) {
            console.error('프레임 순서 변경 실패:', error);
            throw error;
        }
    },

    /**
     * 테마별 프레임 매핑 수 조회
     */
    getThemeFrameMappingCount: async (themeId) => {
        try {
            const response = await apiClient.get(`/theme-frame-mappings/count`, {
                params: { themeId }
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 프레임 매핑 수 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 프레임 중복 체크
     */
    checkFrameDuplicate: async (themeId, photoFrameId) => {
        try {
            const response = await apiClient.get(`/theme-frame-mappings/check-duplicate`, {
                params: { themeId, photoFrameId }
            });
            return response.data.data; // true: 중복됨, false: 사용 가능
        } catch (error) {
            console.error('프레임 중복 체크 실패:', error);
            throw error;
        }
    }
};

export default themeFrameMappingApi;